var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addon-product-container" }, [
    _c(
      "div",
      {
        staticClass: "product-image-container",
        class:
          _vm.canAddMore == false && this.currentQty == 0
            ? "disabled"
            : "available"
      },
      [
        _c("img", {
          attrs: { src: _vm._f("getProductLastImage")(_vm.product) }
        }),
        _vm._v(" "),
        _vm.canAddMore == false && this.currentQty == 0
          ? _c("div", { staticClass: "limit-alert" }, [
              _vm._v(_vm._s(_vm.limitMessage))
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentQty == 0,
                    expression: "currentQty == 0"
                  }
                ],
                staticClass: "happybox-button yellow",
                attrs: { disabled: _vm.canAddMore == false },
                on: {
                  click: function($event) {
                    return _vm.updateProductQuantity(true)
                  }
                }
              },
              [_vm._v("Add to Box")]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentQty > 0,
                    expression: "currentQty > 0"
                  }
                ],
                staticClass: "quantity-container"
              },
              [
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.updateProductQuantity(false)
                      }
                    }
                  },
                  [_vm._v("-")]
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.currentQty) + " per box")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: _vm.limitMessage,
                          show: _vm.shouldHover,
                          trigger: ["manual"],
                          hideOnTargetClick: false
                        },
                        expression:
                          "{content: limitMessage, show: shouldHover, trigger: ['manual'], hideOnTargetClick: false}"
                      }
                    ],
                    on: {
                      mouseenter: function($event) {
                        return _vm.setButtonHover(true)
                      },
                      mouseleave: function($event) {
                        return _vm.setButtonHover(false)
                      },
                      click: function($event) {
                        return _vm.updateProductQuantity(true)
                      }
                    }
                  },
                  [_vm._v("+")]
                )
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }